export default __webpack_public_path__ + "static/gates_foundation-f968c04e3d5a5e2c166baa9c58e3e5c1.png";